<template>
  <q-dialog v-model="confirm" persistent transition-show="fade" transition-hide="fade">
    <div class="hris-modal">
      <q-form @submit="confirmEditingTrainee">
        <div class="hris-modal-header">
          <div>
            <h2 class="hris-modal-title">Edit Trainee</h2>
            <p class="hris-modal-subtitle">Update the trainee's details below.</p>
          </div>
        </div>
        <div class="hris-modal-body">
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="traineeid" label="Trainee ID" :rules="[formRules.required]"></q-input>
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="fname" label="Firstname" :rules="[formRules.required]"></q-input>
            </div>
            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="lname" label="Lastname" :rules="[formRules.required]"></q-input>
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="department" label="Department" :rules="[formRules.required]"></q-input>
            </div>
            <div class="hris-form-field">
              <q-input outlined dense color="green" v-model="max_credit" label="Max Credit" :rules="[formRules.required]"></q-input>
            </div>
          </div>
        </div>
        <div class="hris-modal-footer">
          <q-btn unelevated class="hris-q-ghost" label="Cancel" v-close-popup></q-btn>
          <q-btn unelevated class="hris-q-primary" label="Confirm" type="submit"></q-btn>
        </div>
      </q-form>
    </div>
  </q-dialog>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';

export default {

  data() {
    return {
      confirm:false,
      id:'',
      traineeid:'',
      fname:'',
      lname:'',
      department:'',
      max_credit:''
    }
  },

  created(){
    this.eventHub.$on('editEmployee', this.editEmployee);
  },

  methods: {
   editEmployee:function(obj){
      this.id = obj.obj.id
      this.traineeid = obj.obj.tid
      this.fname = obj.obj.fname
      this.lname = obj.obj.lname
      this.department = obj.obj.department
      this.max_credit = obj.obj.max_credit
      this.confirm = obj.status
   },

   confirmEditingTrainee:function(){
      var formData = new FormData()
      formData.append('id',this.id);
      formData.append('traineeid',this.traineeid);
      formData.append('fname',this.fname);
      formData.append('lname',this.lname);
      formData.append('department',this.department);
      formData.append('max_credit',this.max_credit);

      axios.create({
       baseURL : this.apiUrl,
       headers : {'Authorization' : `Bearer ${this.token}`}
     }).post(`/mobile/pantry/trainee/update`,formData)
     .then((response) => {
       this.confirm = false
       this.eventHub.$emit('refreshList');
     });
   }
}
}
</script>
<style lang="css" scoped>
</style>
